import React, { useEffect, useState } from 'react';
import { Alert, Box, Snackbar, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import SubscriptionForm from '../components/SubscriptionForm';
import { useDispatch, useSelector } from 'react-redux';
import { cancelSubscriptionCreate, createSubscriptionRequest } from '../../api/subscriptions/subscriptionSlice';

const SubscriptionCreatePage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');

  const { isSubscriptionCreated, error } = useSelector((state) => state.subscriptions);

  useEffect(() => {
    if (isSubscriptionCreated) {
      navigate('/subscriptions');
    }
  }, [isSubscriptionCreated, navigate]);

  useEffect(() => {
    if (error) {
      setSnackbarMessage(`${error?.organization_id}`);
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
    }
  }, [error]);

  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbarOpen(false);
  };

  const handleCreate = async (data) => {
    dispatch(createSubscriptionRequest(data));
  };

  function handleCancel() {
    dispatch(cancelSubscriptionCreate());
    return navigate('/subscriptions');
  }

  return (
    <Box elevation={3} sx={{ p: 4 }}>
      <Typography variant="h5" gutterBottom>
        Create Subscription
      </Typography>
      <SubscriptionForm
        onSubmit={handleCreate}
        onCancel={handleCancel}
        buttonText="Save"
        initialData={{
          organization_id: '',
          plan_id: '',
        }}
      />
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert onClose={handleSnackbarClose} severity={snackbarSeverity} sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default SubscriptionCreatePage;
